<template>
  <div class="main-container">
    <div class="left">
      <div class="left-title">买手店</div>
      <el-input v-model="keyword" @input="filterVendor" maxlength="128" size="medium" placeholder="输入买手店名称"></el-input>
      <div class="vender-list" ref="venderList">
        <div class="vendor-item" v-for="(item, index) in vendorList" @click="clickVendor(item, index)" :class="{active: item.vendorId == vendorId}" :key="item.vendorId">{{ item.vendorName }}</div>
      </div>
    </div>
    <div class="vendor">当前：{{ vendorName }}</div>
    <el-tabs v-model="mainTab" type="card" @tab-click="tabClick">
      <el-tab-pane label="Season" name="season"></el-tab-pane>
      <el-tab-pane label="Category" name="category"></el-tab-pane>
    </el-tabs>
    <el-button-group class="mb10">
      <el-button type="primary" size="small" :plain="typeTab !== 1" @click="typeTab = 1">Pass list</el-button>
      <el-button type="primary" size="small" :plain="typeTab !== 2" @click="typeTab = 2">Block list</el-button>
    </el-button-group>
    <template v-if="mainTab === 'season' && vendorId">
      <template v-if="typeTab === 1">
        <table class="table">
          <tr v-for="item in tableData" :key="item.brandId">
            <td valign="top" width="100">
              <div class="brand-name">{{ item.seasonCode }}</div>
            </td>
            <td>
              <el-input v-model="item.boutiqueSeasonName" size="medium" style="width: 200px" @keydown.native.enter="addSeasonMappingPass(item)" maxlength="50" placeholder="boutique Season"></el-input>
              <div class="tag-group">
                <div class="tag" v-for="(tag, index) in item.passArray" :key="index">{{ tag.boutiqueSeasonName }}<i @click="delSeasonMappingPass(item, index)" class="el-icon-circle-close"></i></div>
              </div>
            </td>
          </tr>
        </table>
        <el-pagination
          style="text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </template>
      <template v-else>
        <div class="block-list">
          boutique season code：<el-input v-model="boutiqueSeasonName" size="medium" style="width: 200px" @keydown.native.enter="addSeasonMappingBlock()" maxlength="50" placeholder="boutique Brand"></el-input>
          <div class="tag-group">
            <div class="tag" v-for="(tag, bindex) in blockList" :key="bindex">{{ tag.boutiqueSeasonName }}<i @click="delSeasonMappingBlock(tag)" class="el-icon-circle-close"></i></div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="mainTab === 'category' && vendorId">
      <category v-if="typeTab === 1" ref="category" :vendorId="vendorId"></category>
      <div v-else>
        <el-input style="width: 200px" size="medium" placeholder="L1 Category" maxlength="50" v-model="categoryForm.boutiqueCategory1Name"></el-input>
        <el-input style="width: 200px" size="medium" placeholder="L3 Category or L4Category " maxlength="50" v-model="categoryForm.boutiqueCategory3Name"></el-input>
        <el-button size="medium" type="primary" @click="addCategoryMappingBlock">添加</el-button>
        <el-table :data="categoryBlockList" style="width: 100%">
          <el-table-column prop="boutiqueCategory1Name" label="L1 Category"></el-table-column>
          <el-table-column prop="boutiqueCategory3Name" label="L3 Category or L4Category "></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="delCategoryMappingBlock(scope.row.categoryMapId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right"
          @size-change="handleSizeChangeCategory"
          @current-change="handleCurrentChangeCategory"
          :current-page="categoryQueryForm.currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="categoryQueryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="categoryQueryForm.total">
        </el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import * as _ from "lodash";
import {
  queryVendorListRF,
  getSeasonMappingPassList,
  addSeasonMappingPass,
  delSeasonMappingPass,
  getSeasonMappingBlockList,
  addSeasonMappingBlock,
  delSeasonMappingBlock,
  getCategoryMappingBlockList,
  addCategoryMappingBlock,
  delCategoryMappingBlock,
} from '../../api/mapping';
import Category from './category';

export default {
  components: {
    Category,
  },
  data() {
    return {
      mainTab: 'season',
      typeTab: 1,
      keyword: '',
      queryForm: {
        currentPage: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      vendorList: [],
      vendorId: null,
      vendorName: '',
      blockList: [],
      boutiqueSeasonName: '',
      categoryForm: {
        boutiqueCategory1Name: '',
        boutiqueCategory3Name: '',
      },
      categoryBlockList: [],
      categoryQueryForm: {
        currentPage: 1,
        pageSize: 25,
        total: 0,
      },
    };
  },
  mounted() {
    queryVendorListRF().then(res => {
      if (res.data && res.data.data) {
        this.vendorData = JSON.parse(JSON.stringify(res.data.data));
        this.vendorList = res.data.data;
      }
    });
  },
  methods: {
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getSeasonMappingPassList();
    },
    handleCurrentChange(currentPage) {
      this.queryForm.currentPage = currentPage;
      this.getSeasonMappingPassList();
    },
    filterVendor(query) {
      if (query) {
        const temp = [];
        for (let i = 0; i < this.vendorData.length; i++) {
          if (!this.vendorData[i].vendorName) {
            continue;
          }
          const name = this.vendorData[i].vendorName.toUpperCase();
          const str = query.toUpperCase();
          if (name.startsWith(str)) {
          // if (name.indexOf(str) >= 0) {
            temp.push(this.vendorData[i]);
          }
        }
        this.vendorList = temp;
        this.$nextTick(() => {
          this.$refs.venderList.scrollTop = 0;
        })
      } else {
        this.vendorList = this.vendorData;
        setTimeout(() => {
          this.$refs.venderList.scrollTop = document.querySelector('.vendor-item.active').offsetTop;
        },10)
      }
    },
    clickVendor(item, index) {
      this.vendorId = item.vendorId;
      this.vendorName = item.vendorName;
      this.tableData = [];
      this.total = 0;
      this.blockList = [];
      this.init();
    },
    tabClick() {
      if (this.vendorId) {
        this.init();
      }
    },
    init() {
      if (this.mainTab === 'season') {
        this.getSeasonMappingPassList();
        this.getSeasonMappingBlockList();
      } else {
        if (this.$refs.category) {
          this.$refs.category.trigger();
        }
        this.getCategoryMappingBlockList();
      }
    },
    getSeasonMappingPassList() {
      getSeasonMappingPassList({
        vendorId: this.vendorId,
        currentPage: this.queryForm.currentPage,
        pageSize: this.queryForm.pageSize,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      });
    },
    addSeasonMappingPass(item) {
      if (!item.boutiqueSeasonName) {
        this.$message('请输入内容');
        return;
      }
      addSeasonMappingPass({
        vendorId: this.vendorId,
        seasonCode: item.seasonCode,
        boutiqueSeasonName: item.boutiqueSeasonName,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          if (!item.passArray) {
            item.passArray = [];
          }
          item.passArray.push({
            seasonMapId: res.data.data.seasonMapId,
            boutiqueSeasonName: res.data.data.boutiqueSeasonName,
          });
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      item.boutiqueSeasonName = '';
    },
    delSeasonMappingPass(item, index) {
      delSeasonMappingPass({
        seasonMapId: item.passArray[index].seasonMapId,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          item.passArray.splice(index, 1);
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
    getSeasonMappingBlockList() {
      getSeasonMappingBlockList({
        vendorId: this.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.blockList = res.data.data.list;
        }
      })
    },
    addSeasonMappingBlock() {
      if (!this.boutiqueSeasonName) {
        this.$message('请输入内容');
        return;
      }
      addSeasonMappingBlock({
        vendorId: this.vendorId,
        boutiqueSeasonName: this.boutiqueSeasonName,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.getSeasonMappingBlockList();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      this.boutiqueSeasonName = '';
    },
    delSeasonMappingBlock(tag) {
      delSeasonMappingBlock({
        seasonMapId: tag.seasonMapId
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.getSeasonMappingBlockList();
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
    getCategoryMappingBlockList() {
      getCategoryMappingBlockList({
        vendorId: this.vendorId,
        currentPage: this.categoryQueryForm.currentPage,
        pageSize: this.categoryQueryForm.pageSize,
      }).then(res => {
        if (res.data && res.data.data) {
          this.categoryQueryForm.total = res.data.data.total;
          this.categoryBlockList = res.data.data.list;
        }
      })
    },
    addCategoryMappingBlock() {
      if (!this.categoryForm.boutiqueCategory1Name || !this.categoryForm.boutiqueCategory3Name) {
        this.$message('请补全所有信息');
        return;
      }
      addCategoryMappingBlock({
        vendorId: this.vendorId,
        boutiqueCategory1Name: this.categoryForm.boutiqueCategory1Name,
        boutiqueCategory3Name: this.categoryForm.boutiqueCategory3Name,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.$message.success('添加成功');
          this.getCategoryMappingBlockList();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      });
      this.categoryForm.boutiqueCategory1Name = '';
      this.categoryForm.boutiqueCategory3Name = '';
    },
    delCategoryMappingBlock(categoryMapId) {
      delCategoryMappingBlock({
        categoryMapId,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.$message.success('删除成功');
          this.getCategoryMappingBlockList();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
    handleSizeChangeCategory(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getSeasonMappingPassList();
    },
    handleCurrentChangeCategory(currentPage) {
      this.queryForm.currentPage = currentPage;
      this.getSeasonMappingPassList();
    },
  }
};
</script>

<style lang="less" scoped>
.mb10 {
  margin-bottom: 10px;
}
.main-container {
  position: relative;
  min-height: 100%;
  padding: 10px 10px 10px 190px;

  .left {
    position: absolute;
    top: 0;
    left: 10px;
    bottom: 0;
    width: 170px;
    padding-right: 10px;
    border-right: 1px solid #E4E7ED;
  }
  .left-title {
    font-size: 14px;
    line-height: 40px;
  }
  .vender-list {
    position: absolute;
    top: 85px;
    left: 0;
    bottom: 0;
    right: 4px;
    overflow: auto;
  }
  .vendor-item {
    padding: 7px 10px;
    font-size: 14px;
    text-align: right;
    word-break: break-all;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background-color: #f5f7fa;
    }
    &.active {
      color: #fff;
      background-color: #409EFF;
    }
  }
}
.vendor {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
.search {
  display: block;
  width: 310px;
  margin-bottom: 10px;
}
.table {
  width: 100%;
  margin-bottom: 10px;
  border-spacing: 0;
  border-collapse: collapse;

  tr{
    border-bottom: 1px solid #ebeef5;

    &:hover {
      background-color: #f5f7fa;
    }
  }
  td {
    padding: 10px;
  }
}
.brand-name {
  margin-top: 8px;
  font-size: 16px;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.tag {
  position: relative;
  margin: 10px 10px 0 0;
  padding: 5px 26px 5px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  i {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 5px;
    margin-top: -16px;
    line-height: 100%;
    cursor: pointer;

    &:hover {
      color: #000;
      font-weight: bold;
    }
  }

  &:hover{
    border-color: #C0C4CC;
  }
}
</style>
